import { MinimalWordGraph } from "word-graphs";
import wordList from "./twl06.json";

export const WordList = new MinimalWordGraph();
(wordList as any).words.sort().forEach((w: string) => WordList.add(w));
WordList.makeImmutable();
